import { render, staticRenderFns } from "./WorkGlobalQuestionDialog.vue?vue&type=template&id=d5293a70"
import script from "./WorkGlobalQuestionDialog.vue?vue&type=script&lang=js"
export * from "./WorkGlobalQuestionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports